import React from 'react';
import { useBooth } from '../../../../../hooks/useBooth';
import { Booth } from '../../../../../interfaces/interfaces';
import { VyImage } from '../../../../common/VyImage';

interface ChildBoothProps {
  booth: Booth;
}

const ChildBooth = ({ booth }: ChildBoothProps) => {
  const { openBooth } = useBooth();

  return (
    <div
      onClick={() => openBooth(booth?._id)}
      className="flex flex-col justify-end w-full relative h-40 rounded-2xl bg-cover cursor-pointer"
      style={{ background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))' }}>
      {booth.backgroundImage && <VyImage id={booth.backgroundImage} className="absolute w-full h-full object-cover rounded-2xl" style={{ zIndex: -1 }} />}
      <p className="text-white text-xs mx-3 my-2">{booth.boothnumber}</p>
      <h2 className="text-white font-bold mx-3 my-2">{booth.name}</h2>
    </div>
  );
};

export default ChildBooth;
